import { Suspense, lazy } from 'react';

import type { BuilderCanvasProps } from './BuilderCanvas';

/**
 * React Flow must stay out of the entry bundle and out of every route that
 * never draws a graph (constitution Principle 6). Route-level splitting alone
 * does not achieve it: this route evaluates its search schema eagerly, which
 * pulls its module — and everything that module imports — into the eager graph.
 * An explicit boundary here does not care how the route is split.
 *
 * The fallback mirrors the canvas's own frame, so nothing shifts when the real
 * module resolves.
 */
const BuilderCanvas = lazy(() =>
  import('./BuilderCanvas').then((module) => ({
    default: module.BuilderCanvas,
  })),
);

function BuilderCanvasFallback() {
  return (
    <div
      className="border-border bg-background h-full w-full animate-pulse rounded-lg border"
      aria-hidden="true"
    />
  );
}

export function BuilderCanvasLazy(props: BuilderCanvasProps) {
  return (
    <Suspense fallback={<BuilderCanvasFallback />}>
      <BuilderCanvas {...props} />
    </Suspense>
  );
}
